/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Robots_TxtInputs */

const en_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt`)
};

const ar_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt`)
};

const bn_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt`)
};

const de_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt`)
};

const es_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt`)
};

const fr_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt`)
};

const pt_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robôs.txt`)
};

const zh_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机器人.txt`)
};

const tr_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt`)
};

const ru_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt`)
};

const pl_svchip_robots_txt = /** @type {(inputs: Svchip_Robots_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robots.txt`)
};

/**
* | output |
* | --- |
* | "Robots.txt" |
*
* @param {Svchip_Robots_TxtInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_robots_txt = /** @type {((inputs?: Svchip_Robots_TxtInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Robots_TxtInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_robots_txt(inputs)
	if (locale === "bn") return bn_svchip_robots_txt(inputs)
	if (locale === "de") return de_svchip_robots_txt(inputs)
	if (locale === "es") return es_svchip_robots_txt(inputs)
	if (locale === "fr") return fr_svchip_robots_txt(inputs)
	if (locale === "pt") return pt_svchip_robots_txt(inputs)
	if (locale === "zh") return zh_svchip_robots_txt(inputs)
	if (locale === "tr") return tr_svchip_robots_txt(inputs)
	if (locale === "ru") return ru_svchip_robots_txt(inputs)
	if (locale === "pl") return pl_svchip_robots_txt(inputs)
	return en_svchip_robots_txt(inputs)
});